import { Material, Mesh } from 'three';
export const traverseObject3DMaterials = (object3D, callback) => {
    object3D.traverse(child => {
        if (child instanceof Mesh && child.material instanceof Material) {
            callback(child.material);
        }
    });
};
export function isMesh(object3D) {
    return object3D.isMesh === true;
}
export function isGroup(object3D) {
    return object3D.isGroup === true;
}
function cloneMesh(mesh) {
    // @ts-ignore
    return new mesh.constructor(mesh.geometry, mesh.material);
}
export function makeOverflowMeshes(mesh, offset = 1, parent) {
    const root = parent !== null && parent !== void 0 ? parent : mesh.parent;
    if (root === null || root === undefined)
        throw new Error('No valid parent to add overflow meshes to');
    const leftMesh = cloneMesh(mesh);
    const rightMesh = cloneMesh(mesh);
    leftMesh.position.x = mesh.position.x - offset;
    rightMesh.position.x = mesh.position.x + offset;
    leftMesh.layers.set(1);
    rightMesh.layers.set(1);
    mesh.layers.set(1);
    root.add(leftMesh);
    root.add(rightMesh);
    return () => {
        root.remove(leftMesh);
        root.remove(rightMesh);
    };
}
// technically not accurate to how three sorts objects, but good enough for editor scene structure
export function inheritedRenderOrder(object3d) {
    let it = object3d;
    while (it.renderOrder === 0 && it.parent !== null && isGroup(it.parent)) {
        it = it.parent;
    }
    return it.renderOrder;
}
export function groupOrder(object3d) {
    let it = object3d;
    while (it.parent !== null && !isGroup(it))
        it = it.parent;
    if (isGroup(it))
        return it.renderOrder;
    else
        return 0;
}
export function bubbleInputEvent(eventName, object3d) {
    var _a;
    const handler = (_a = object3d.userData) === null || _a === void 0 ? void 0 : _a[eventName];
    if (handler !== undefined)
        handler();
    if (object3d.parent !== null)
        bubbleInputEvent(eventName, object3d.parent);
}
export function bubbleHasInputEvent(eventNames, object3d) {
    if (eventNames.some(it => { var _a; return ((_a = object3d.userData) === null || _a === void 0 ? void 0 : _a[it]) !== undefined; }))
        return true;
    else if (object3d.parent !== null)
        return bubbleHasInputEvent(eventNames, object3d.parent);
    else
        return false;
}
